import script from "./DevPanelTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./DevPanelTrigger.vue?vue&type=script&setup=true&lang=ts"

import "./DevPanelTrigger.vue?vue&type=style&index=0&id=ba68996a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba68996a"]])

export default __exports__